// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_d3_index_js"], function() { return __webpack_require__("../.rbenv/versions/2.7.5/lib/ruby/gems/2.7.0/bundler/gems/decidim-e85c208edf36/decidim-assemblies/app/packs/entrypoints/decidim_assemblies.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
